$(function () {
    /* eslint-disable */

    var $tableMouse = $('#table-mouse-settings');
    var tableMouse = false;
    var $tableFortniteVide1 = $('#table-video-settings-1');
    var tableFortniteVide1 = false;
    var $tableFortniteVide2 = $('#table-video-settings-2');
    var tableFortniteVide2 = false;
    var $tableFortniteVide3 = $('#table-video-settings-3');
    var tableFortniteVide3 = false;
    var $tableValorantVideo = $('#table-video-settings-valorant');
    var tableValorantVideo = false;
    var $tableCsVideo = $('#table-video-settings-cs');
    var tableCsVideo = false;
    var $tableGame = $('#table-game-settings');
    var tableGame = false;
    var $tableAudio = $('#table-audio-settings');
    var tableAudio = false;
    var $tableNvidia = $('#table-nvidia-settings');
    var tableNvidia = false;

    function getScrollbarWidth() {
        return window.innerWidth - document.documentElement.clientWidth;
    }

    var datatableBreakpoints = [
        { name: 'desktopInf', width: Infinity },
        { name: 'desktopMd', width: 1199 - getScrollbarWidth()},
        { name: 'desktopSM', width: 991 },
    ]


    function tableInit () {
        tableMouse = $tableMouse.DataTable({
            info: false,
            paging: false,
            searching: false,
            ordering: false,
            autoWidth: false,
            columnDefs: [
                { "targets": 5, className: "min-desktopInf" },
                { "targets": 4, className: "min-desktopInf" },
                { "targets": 3, className: "min-desktopMd" },
                { "targets": 2, className: "min-desktopMd" },
            ],
            responsive: {
                breakpoints: datatableBreakpoints,
                details: {
                    display: childRowAlwaysShow
                }
            }
        });

        tableFortniteVide1 = $tableFortniteVide1.DataTable({
            info: false,
            paging: false,
            searching: false,
            ordering: false,
            autoWidth: false,
            columnDefs: [
                { "targets": 5, className: "min-desktopInf" },
                { "targets": 4, className: "min-desktopInf" },
                { "targets": 3, className: "min-desktopMd" },
                { "targets": 2, className: "min-desktopMd" },
            ],
            responsive: {
                breakpoints: datatableBreakpoints,
                details: {
                    display: childRowAlwaysShow
                }
            }
        });


        function childRowAlwaysShow(row, update, render) {
            // Display
            row.child( render(), 'child' ).show();
            $( row.node() ).addClass( 'parent' );

            return true;
        }

        tableFortniteVide2 = $tableFortniteVide2.DataTable({
            info: false,
            paging: false,
            searching: false,
            ordering: false,
            autoWidth: false,
            columnDefs: [
                { "targets": 5, className: "min-desktopInf" },
                { "targets": 4, className: "min-desktopInf" },
                { "targets": 3, className: "min-desktopMd" },
                { "targets": 2, className: "min-desktopMd" },
            ],
            responsive: {
                breakpoints: datatableBreakpoints,
                details: {
                    display: childRowAlwaysShow
                }
            }
        });

        tableFortniteVide3 = $tableFortniteVide3.DataTable({
            info: false,
            paging: false,
            searching: false,
            ordering: false,
            autoWidth: false,
            columnDefs: [
                { "targets": 5, className: "min-desktopInf" },
                { "targets": 4, className: "min-desktopInf" },
                { "targets": 3, className: "min-desktopMd" },
                { "targets": 2, className: "min-desktopMd" },
            ],
            responsive: {
                breakpoints: datatableBreakpoints,
                details: {
                    display: childRowAlwaysShow
                }
            }
        });

        tableCsVideo = $tableCsVideo.DataTable({
            info: false,
            paging: false,
            searching: false,
            ordering: false,
            autoWidth: false,
            columnDefs: [
                { "targets": 5, className: "min-desktopInf" },
                { "targets": 4, className: "min-desktopInf" },
                { "targets": 3, className: "min-desktopMd" },
                { "targets": 2, className: "min-desktopMd" },
            ],
            responsive: {
                breakpoints: datatableBreakpoints,
                details: {
                    display: childRowAlwaysShow
                }
            }
        });

        tableValorantVideo = $tableValorantVideo.DataTable({
            info: false,
            paging: false,
            searching: false,
            ordering: false,
            autoWidth: false,
            columnDefs: [
                { "targets": 5, className: "min-desktopInf" },
                { "targets": 4, className: "min-desktopInf" },
                { "targets": 3, className: "min-desktopMd" },
                { "targets": 2, className: "min-desktopMd" },
            ],
            responsive: {
                breakpoints: datatableBreakpoints,
                details: {
                    display: childRowAlwaysShow
                }
            }
        });

        tableGame = $tableGame.DataTable({
            info: false,
            paging: false,
            searching: false,
            ordering: false,
            autoWidth: false,
            columnDefs: [
                { "targets": 5, className: "min-desktopInf" },
                { "targets": 4, className: "min-desktopInf" },
                { "targets": 3, className: "min-desktopMd" },
                { "targets": 2, className: "min-desktopMd" },
            ],
            responsive: {
                breakpoints: datatableBreakpoints,
                details: {
                    display: $.fn.dataTable.Responsive.display.childRowImmediate,
                }
            }
        });

        tableAudio = $tableAudio.DataTable({
            info: false,
            paging: false,
            searching: false,
            ordering: false,
            autoWidth: false,
            columnDefs: [
                { "targets": 5, className: "min-desktopInf" },
                { "targets": 4, className: "min-desktopInf" },
                { "targets": 3, className: "min-desktopMd" },
                { "targets": 2, className: "min-desktopMd" },
            ],
            responsive: {
                breakpoints: datatableBreakpoints,
                details: {
                    display: $.fn.dataTable.Responsive.display.childRowImmediate,
                }
            }
        });


        tableNvidia = $tableNvidia.DataTable({
            info: false,
            paging: false,
            searching: false,
            ordering: false,
            autoWidth: false,
            columnDefs: [
                { "targets": 5, className: "min-desktopInf" },
                { "targets": 4, className: "min-desktopInf" },
                { "targets": 3, className: "min-desktopMd" },
                { "targets": 2, className: "min-desktopMd" },
            ],
            responsive: {
                breakpoints: datatableBreakpoints,
                details: {
                    display: $.fn.dataTable.Responsive.display.childRowImmediate,
                }
            }
        });
    }

    tableInit();




});
